export type HomeCommunityAssistVariant = "minimal" | "richer";

export type HomeCommunityAssistExperimentConfig = {
  enabled: boolean;
  minImpressionsPerVariant: number;
  minImpactLiftPct: number;
  minConfidence: number;
  forcedVariant: HomeCommunityAssistVariant | null;
  updatedAt: string;
  lastAutoPromotedAt?: string;
};

export const HOME_COMMUNITY_ASSIST_VARIANT_KEY = "tension_home_community_assist_variant_v1";
export const HOME_COMMUNITY_ASSIST_EXPERIMENT_KEY =
  "tension_home_community_assist_experiment_v1";

export const DEFAULT_HOME_COMMUNITY_ASSIST_EXPERIMENT: HomeCommunityAssistExperimentConfig = {
  enabled: false,
  minImpressionsPerVariant: 20,
  minImpactLiftPct: 2,
  minConfidence: 65,
  forcedVariant: null,
  updatedAt: new Date().toISOString(),
};

export function readHomeCommunityAssistExperimentConfig(): HomeCommunityAssistExperimentConfig {
  try {
    const raw = localStorage.getItem(HOME_COMMUNITY_ASSIST_EXPERIMENT_KEY);
    const parsed = raw ? JSON.parse(raw) : null;
    if (!parsed || typeof parsed !== "object") {
      return DEFAULT_HOME_COMMUNITY_ASSIST_EXPERIMENT;
    }
    return {
      enabled: Boolean(parsed.enabled),
      minImpressionsPerVariant: Math.min(
        500,
        Math.max(5, Number(parsed.minImpressionsPerVariant || 20)),
      ),
      minImpactLiftPct: Math.min(20, Math.max(0.5, Number(parsed.minImpactLiftPct || 2))),
      minConfidence: Math.min(95, Math.max(40, Number(parsed.minConfidence || 65))),
      forcedVariant:
        parsed.forcedVariant === "minimal" || parsed.forcedVariant === "richer"
          ? parsed.forcedVariant
          : null,
      updatedAt: typeof parsed.updatedAt === "string" ? parsed.updatedAt : new Date().toISOString(),
      lastAutoPromotedAt:
        typeof parsed.lastAutoPromotedAt === "string" ? parsed.lastAutoPromotedAt : undefined,
    };
  } catch {
    return DEFAULT_HOME_COMMUNITY_ASSIST_EXPERIMENT;
  }
}

export function writeHomeCommunityAssistExperimentConfig(
  config: HomeCommunityAssistExperimentConfig,
): void {
  try {
    localStorage.setItem(HOME_COMMUNITY_ASSIST_EXPERIMENT_KEY, JSON.stringify(config));
  } catch {
    // noop
  }
}

